import React from "react";
import styles from "./style/TutorSignupWhyChoose.module.css";

const benefits = [
  {
    icon: "groups",
    title: "Reach serious learners",
    text: "Get discovered by students and parents who are actively looking for quality tutoring—not random leads.",
  },
  {
    icon: "workspace_premium",
    title: "Professional presence",
    text: "Showcase your subjects, experience, and strengths in a clear profile that builds trust upfront.",
  },
  {
    icon: "chat",
    title: "Smoother communication",
    text: "Keep enquiries and follow-ups organized so you spend less time coordinating and more time teaching.",
  },
  {
    icon: "support_agent",
    title: "Help when you need it",
    text: "Our team supports you with onboarding, visibility, and using the platform day to day.",
  },
];

const TutorSignupWhyChoose = () => {
  return (
    <section className={styles.section} aria-labelledby="why-tutor-heading">
      <div className={styles.inner}>
        <h2 id="why-tutor-heading" className={styles.title}>
          Why tutors choose Book My Tuitions
        </h2>
        <p className={styles.lead}>
          Whether you teach part-time or full-time, Book My Tuitions helps you connect
          with the right students, present your expertise clearly, and grow your teaching
          practice with less admin overhead.
        </p>

        <h3 className={styles.subheading}>What you get as a tutor</h3>
        <ul className={styles.grid}>
          {benefits.map((item) => (
            <li key={item.title} className={styles.card}>
              <div className={styles.iconWrap}>
                <span
                  className={`material-symbols-outlined ${styles.icon}`}
                  aria-hidden
                >
                  {item.icon}
                </span>
              </div>
              <h4 className={styles.cardTitle}>{item.title}</h4>
              <p className={styles.cardText}>{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TutorSignupWhyChoose;
